<script>
	import SmartLink from '../../../../helpers/SmartLink.svelte';
	import { scaleAdOnHover, startAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// CFIT-V0055_Langhantel-Paar-A-720x480-adform
		cfitRec: {
			element: false,
			fallbackImgUrl: './../commercial/01.Home/04.apps-und-ads/cfitRec/fallback.webp',
			imageAltText: 'clever Fit - interactive Ad',
			iframeIndexUrl: './../commercial/01.Home/04.apps-und-ads/cfitRec/index.html',
			playTimeMs: 13000,
			playing: false,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 720,
			origHeight: 480
		}
	};
</script>

<div>
	<div class="flex structure marginbox_left">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Tabletmonitor mit Darstellung der TOM-App"
					 src="./img/01.Home/04.apps-und-ads/TOMapp-Tablet-2_K.webp">
			</div>
			<div class="flex element">
				<div class="content block-to-flex">
					<h2 class="left">{getText("01.04.01_h2")}</h2>
				</div>
			</div>
			<div class="flex element wrap">
				<div class="content">
					<p class="caption">{getText("01.04.02_caption")}</p>
				</div>
				<SmartLink extraClass="see_more_button w_100_60" text="Mehr erfahren" url="portfolio/individuelle_klasse#tom"/>
			</div>
		</div>

		<div class="flex structure-2">
			<div class="flex element rec">
				<!-- Beginning - Ad: cfitRec -->
				<div bind:this={ads.cfitRec.element} class="content"
					 style="
					 --scale: {ads.cfitRec.scale};
					 --origWidth: {ads.cfitRec.origWidth || 0}px;
					 --origHeight: {ads.cfitRec.origHeight || 0}px;
				">
					<div use:scaleAdOnHover={ads.cfitRec} class="commercial scale_inner_container no_ad_bg"
					class:playing={ads.cfitRec.playing} on:click={() => startAd(ads.cfitRec, () => ads = ads)}>
						<!-- PLAYING -->
						<img loading="lazy" alt="Website-Screenshot"
							 src="./../img/01.Home/04.apps-und-ads/cfit-hintergrund.webp">
						{#if ads.cfitRec.playing}
							<div class="container-overlay">
								<img loading="lazy" alt={ads.cfitRec.imageAltText} src={ads.cfitRec.fallbackImgUrl}/>
								<iframe class="scaled-iframe" scrolling="no" src={ads.cfitRec.iframeIndexUrl}
										style="--bg-image: url('{ads.cfitRec.fallbackImgUrl}')"
										on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
							</div>
						{:else}
							<div class="container-overlay">
								<img loading="lazy" alt={ads.cfitRec.imageAltText} src={ads.cfitRec.fallbackImgUrl}/>
								<button aria-label="play Ad - {ads.cfitRec.imageAltText}" class="playbutton"></button>
							</div>
						{/if}
					</div>
				</div>
				<!-- End - Ad -->
			</div>
		</div>

		<div class="flex structure-3">
			<div class="headline"><h2 class="balance">{getText("01.04.03_h2")}</h2></div>
			<p class="caption">{getText("01.04.04_caption")}</p>
			<SmartLink extraClass="see_more_button w_20 align-right" text="Mehr erfahren" url="portfolio/stream_on"/>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";

	.flex {
		display: flex;
		box-sizing: border-box;
	}

	.row {
		flex-flow: row wrap;
	}

	.col {
		flex-flow: column wrap;
	}

	.element {
		min-width: 100px;
		width: 100%;

		&.wrap {
			flex-wrap: wrap;
		}
	}

	.content {
		flex: 1 100%;
	}

	.structure {
		flex-flow: row wrap;
		margin-bottom: $spacing-mobile-half;
	}

	.structure-1 {
		flex-shrink: 1;
		width: auto;
		margin: $spacing-mobile;

		@include for-tablet-portrait-up {
			width: 40%;
			margin: 0;
			padding: 0 $media-gap 0 0;
		}

		img {
			margin-bottom: $spacing-mobile*.5;
		}

		.block-to-flex {
			display: block;

			@include for-tablet-portrait-up {
				display: flex;
			}
		}

		h2.left {
			display: inline-block;
			float: left;
			width: 100%;
		}
	}

	.structure-2 {
		flex-shrink: 0;
		width: 100%;

		@include for-tablet-portrait-up {
			width: 60%;
			margin: 0;
		}

		@include for-desktop-up {
			justify-content: flex-start;
			padding: px-to-rem(100) 0 0 0;
		}

		.commercial {
			width: 100%;
			height: unset;
		}
		.rec {
			max-width: unset;
			max-height: unset;
			position: relative;
		}
	}

	.structure-3 {
		width: 100%;
		margin: 0 1.9em 1.9em 1.9em;
		flex-wrap: wrap;

		@include for-tablet-portrait-up {
			margin: 0;
			padding: 0;
		}

		@include for-desktop-up {
			flex-shrink: 0;
		}

		.headline {
			width: 35%;
			padding-right: $media-gap;
			word-break: break-word;
			hyphens: auto;
			display: flex;
			flex-direction: row-reverse;

			@include for-tablet-portrait-up {
				width: 40%;
				text-align: right;
				padding-left: $spacing-mobile;
			}
		}

		p {
			width: 65%;

			@include for-tablet-portrait-up {
				width: 40%;
				padding-right: $media-gap;
			}
		}

		:global(.see_more_button) {
			margin-left: 35%;

			@include for-tablet-portrait-up {
				margin-left: 0;
				padding-right: $spacing-mobile;
			}
		}
	}

	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	h2 {
		margin-bottom: $spacing-mobile-one-third;
	}

	p:first-of-type {
		margin-bottom: $media-gap;
	}

	.rec {
		max-width: 720px;
		max-height: 480px;
		margin: 0 0 $media-gap 0;
		flex-grow: 1;

		@include for-tablet-portrait-up {
			margin: 0 0 $media-gap 0;
		}

		.commercial {
			overflow: hidden;
		}

		.container-overlay {
			position: absolute;
			width: 80%;
			height: fit-content;
			left: 10%;
			top: 18%;

			@include for-desktop-up {
				top: 11%;
			}
		}

		.scaled-iframe {
			width: 720px;
			height: 480px;
			border: 0;

			zoom: 1;
			transform: scale(1);
			transform-origin: 0 0;
			position: absolute;
			left: 0;
			top: 0;

			// 0.8 as equivalent to 80% (see above)
			scale: calc(var(--scale) * 0.8) !important;
			height: calc(var(--origHeight)) !important;
			width: calc(var(--origWidth)) !important;
		}
	}

	.playing .container-overlay > img {
		opacity: 0;
	}

	.rec iframe {
		width: 100%;
		height: 100%;

		position: absolute;
		left: 0;
	}

	iframe {
		border: none;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(iframe[loaded]) {
		background-image: none;
	}

	:global(.align-right) {
		float: right;
		text-align: right;

		:global(a) {
			padding-right: 0;
		}
	}

	:global(.w_100_60) {
		@include for-tablet-portrait-up {
			width: 60%;
		}
	}

	:global(.w_20) {
		@include for-tablet-portrait-up {
			width: 20%;
		}
	}
</style>
